/**
 * Ko'rsatish formatlari.
 *
 * Miqdorlar MATN sifatida keladi va matn sifatida qoladi: son
 * turiga o'tkazish yaxlitlash xatosini kiritardi (dev_spec.md §7.2).
 * Bu yerda faqat ORTIQCHA nollar olib tashlanadi.
 */
export function qty(value: string | undefined | null): string {
  if (!value) return "—";
  const trimmed = value.trim();
  if (!trimmed) return "—";
  if (!trimmed.includes(".")) return trimmed;
  return trimmed.replace(/\.?0+$/, "") || "0";
}

export function text(value: string | undefined | null): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : "—";
}

/** Qisqa identifikator: to'liq UUID jadvalda joy egallaydi. */
export function shortId(value: string | undefined | null): string {
  if (!value) return "—";
  return value.slice(0, 8);
}

const DATE_TIME = new Intl.DateTimeFormat("uz-UZ", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

export function dateTime(value: string | undefined | null): string {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "—";
  return DATE_TIME.format(parsed);
}

/** «3 daqiqa oldin» — kechikishni o'qish uchun. */
export function relative(value: string | undefined | null): string {
  if (!value) return "—";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "—";

  const seconds = Math.round((Date.now() - parsed.getTime()) / 1000);
  if (seconds < 60) return "hozir";
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} daqiqa oldin`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} soat oldin`;
  const days = Math.round(hours / 24);
  return `${days} kun oldin`;
}

export function duration(seconds: string | number | undefined | null): string {
  const total = typeof seconds === "string" ? Number(seconds) : seconds;
  if (!total || Number.isNaN(total)) return "—";
  if (total < 60) return `${Math.round(total)} s`;
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes} daq`;
  const hours = Math.floor(minutes / 60);
  return `${hours} s ${minutes % 60} daq`;
}

export function bytes(value: number | undefined | null): string {
  if (!value) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = value;
  let unit = 0;
  while (size >= 1024 && unit < units.length - 1) {
    size /= 1024;
    unit += 1;
  }
  return `${size.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`;
}
